import { Observer } from 'mobx-react';
import * as React from 'react';
import styled from 'styled-components';

import { data, generateIsBibs } from '../../derivations';
import { MobileSingleItem } from './MobileSingleItem';
import { MobileTeamItem } from './MobileTeamItem';

type Props = {
  distanceId: number;
  type: 'single' | 'team';
};

const ComponentByType = {
  single: MobileSingleItem,
  team: MobileTeamItem,
};

const Wrapper = styled.div`
  margin-bottom: 30px;
`;

export const MobileRacerList: React.FC<Props> = (props) => {
  const { distanceId, type } = props;

  const dataGenerator = data.generateDataEntries(distanceId);
  const isBib = generateIsBibs(distanceId);

  return (
    <Wrapper>
      <Observer>
        {() => {
          const data: any[] = dataGenerator.get();
          const withBibs = isBib.get();
          if (!data) return null;

          const Component = ComponentByType[type];

          return (
            <>
              {data.map((item) => (
                <Component key={`mobile-${item.id}`} value={item} withBibs={withBibs} />
              ))}
            </>
          );
        }}
      </Observer>
    </Wrapper>
  );
};
